import { tMonth } from "pages/WeddingDate/WeddingDate";
import React from "react";
import styles from "./style.module.css";

interface Props {
  list?: string[];
  onClick?: (item: string, propsValue: string) => void;
  style?: React.CSSProperties;
  propsValue: string;
  yearText?: tMonth[];
}

export default function TagList({
  list,
  onClick,
  style,
  propsValue,
  yearText,
}: Props) {
  return (
    <div className={styles.tagList} style={{ ...style }}>
      {list?.map((item) => (
        <span key={item}>
          {item}
          <button type="button" onClick={() => onClick?.(item, propsValue)} />
        </span>
      ))}
    </div>
  );
}
